import React from 'react';
import catHappyDerpGif from '../assets/Q3/cat_happy_derp.gif';

function Q3({ question = 3, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm *the* title</span>
        <h1>Project Valen</h1>
        <p>You waved back, hehe</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q3__center">
      <span className="secretpin__title q3__greeting">Do you know what this is?</span>
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q3__wave-button"
        onClick={() => onNavigate?.('q4')}
      >
        Humm...
      </button>
      <img src={catHappyDerpGif} alt="" className="q3__gif" />
    </div>
  </div>
  );
}

export default Q3;
